import React from 'react';
import SeoBodyKalufkiRanfors, {
  SeoHeader as SeoHeaderKalufkiRanfors,
  seoMeta as seoMetaKalufkiRanfors
} from './seo/SeoProductsKalufkiRanfors';
import SeoBodyKalufkiSaten, {
  SeoHeader as SeoHeaderKalufkiSaten,
  seoMeta as seoMetaKalufkiSaten
} from './seo/SeoProductsKalufkiSaten';
import SeoBodyPlikoveRanfors, {
  SeoHeader as SeoHeaderPlikoveRanfors,
  seoMeta as seoMetaPlikoveRanfors
} from './seo/SeoProductsPlikoveRanfors';
import SeoBodyPlikoveSaten, {
  SeoHeader as SeoHeaderPlikoveSaten,
  seoMeta as seoMetaPlikoveSaten
} from './seo/SeoProductsPlikoveSaten';
import SeoBodyKrugliRanfors, {
  SeoHeader as SeoHeaderKrugliRanfors,
  seoMeta as seoMetaKrugliRanfors
} from './seo/SeoProductsKrugliRanfors';
import SeoBodyKrugliSaten, {
  SeoHeader as SeoHeaderKrugliSaten,
  seoMeta as seoMetaKrugliSaten
} from './seo/SeoProductsKrugliSaten';
import SeoBodyCharshafiRanfors, {
  SeoHeader as SeoHeaderCharshafiRanfors,
  seoMeta as seoMetaCharshafiRanfors
} from './seo/SeoProductsCharshafiRanfors';
import SeoBodyCharshafiSaten, {
  SeoHeader as SeoHeaderCharshafiSaten,
  seoMeta as seoMetaCharshafiSaten
} from './seo/SeoProductsCharshafiSaten';
import SeoBodyFittedSheetsRanfors, {
  SeoHeader as SeoHeaderFittedSheetsRanfors,
  seoMeta as seoMetaFittedSheetsRanfors
} from './seo/SeoProductsFittedSheetsRanfors';
import SeoBodyFittedSheetsSaten, {
  SeoHeader as SeoHeaderFittedSheetsSaten,
  seoMeta as seoMetaFittedSheetsSaten
} from './seo/SeoProductsFittedSheetsSaten';
import SeoBodyDetskiCharshafiRanfors, {
  SeoHeader as SeoHeaderDetskiCharshafiRanfors,
  seoMeta as seoMetaDetskiCharshafiRanfors
} from './seo/SeoProductsDetskiCharshafiRanfors';
import SeoBodyDetskiCharshafiSaten, {
  SeoHeader as SeoHeaderDetskiCharshafiSaten,
  seoMeta as seoMetaDetskiCharshafiSaten
} from './seo/SeoProductsDetskiCharshafiSaten';
import SeoBodyDetskiKalufkiRanfors, {
  SeoHeader as SeoHeaderDetskiKalufkiRanfors,
  seoMeta as seoMetaDetskiKalufkiRanfors
} from './seo/SeoProductsDetskiKalufkiRanfors';
import SeoBodyDetskiKalufkiSaten, {
  SeoHeader as SeoHeaderDetskiKalufkiSaten,
  seoMeta as seoMetaDetskiKalufkiSaten
} from './seo/SeoProductsDetskiKalufkiSaten';
import SeoBodyDetskiCharshafiSLastikRanfors, {
  SeoHeader as SeoHeaderDetskiCharshafiSLastikRanfors,
  seoMeta as seoMetaDetskiCharshafiSLastikRanfors
} from './seo/SeoProductsDetskiCharshafiSLastikRanfors';
import SeoBodyDetskiCharshafiSLastikSaten, {
  SeoHeader as SeoHeaderDetskiCharshafiSLastikSaten,
  seoMeta as seoMetaDetskiCharshafiSLastikSaten
} from './seo/SeoProductsDetskiCharshafiSLastikSaten';
import SeoBodyDetskiPlikoveRanfors, {
  SeoHeader as SeoHeaderDetskiPlikoveRanfors,
  seoMeta as seoMetaDetskiPlikoveRanfors
} from './seo/SeoProductsDetskiPlikoveRanfors';
import SeoBodyDetskiPlikoveSaten, {
  SeoHeader as SeoHeaderDetskiPlikoveSaten,
  seoMeta as seoMetaDetskiPlikoveSaten
} from './seo/SeoProductsDetskiPlikoveSaten';

// Combined "all materials" variants - shown on the mixed products page (no :materialId selected).
import SeoBodySub1Charshafi, {
  SeoHeader as SeoHeaderSub1Charshafi,
  seoMeta as seoMetaSub1Charshafi
} from './seo/SeoSub1Charshafi';
import SeoBodySub2Kalufki, {
  SeoHeader as SeoHeaderSub2Kalufki,
  seoMeta as seoMetaSub2Kalufki
} from './seo/SeoSub2Kalufki';
import SeoBodySub3CharshafiSLastik, {
  SeoHeader as SeoHeaderSub3CharshafiSLastik,
  seoMeta as seoMetaSub3CharshafiSLastik
} from './seo/SeoSub3CharshafiSLastik';
import SeoBodySub4Plikove, {
  SeoHeader as SeoHeaderSub4Plikove,
  seoMeta as seoMetaSub4Plikove
} from './seo/SeoSub4Plikove';
import SeoBodySub6KrugliCharshafi, {
  SeoHeader as SeoHeaderSub6KrugliCharshafi,
  seoMeta as seoMetaSub6KrugliCharshafi
} from './seo/SeoSub6KrugliCharshafi';
import SeoBodyCat2Sub7DetskiCharshafi, {
  SeoHeader as SeoHeaderCat2Sub7DetskiCharshafi,
  seoMeta as seoMetaCat2Sub7DetskiCharshafi
} from './seo/SeoCat2Sub7DetskiCharshafi';
import SeoBodyCat2Sub8DetskiKalufki, {
  SeoHeader as SeoHeaderCat2Sub8DetskiKalufki,
  seoMeta as seoMetaCat2Sub8DetskiKalufki
} from './seo/SeoCat2Sub8DetskiKalufki';
import SeoBodyCat2Sub9DetskiCharshafiSLastik, {
  SeoHeader as SeoHeaderCat2Sub9DetskiCharshafiSLastik,
  seoMeta as seoMetaCat2Sub9DetskiCharshafiSLastik
} from './seo/SeoCat2Sub9DetskiCharshafiSLastik';
import SeoBodyCat2Sub10DetskiPlikove, {
  SeoHeader as SeoHeaderCat2Sub10DetskiPlikove,
  seoMeta as seoMetaCat2Sub10DetskiPlikove
} from './seo/SeoCat2Sub10DetskiPlikove';

export function getProductSeoMeta(categoryId, subCategoryId, materialId) {
  if (categoryId === '1' && subCategoryId === '1') {
    if (materialId === '2') return seoMetaCharshafiRanfors;
    if (materialId === '1') return seoMetaCharshafiSaten;
    return seoMetaSub1Charshafi;
  }
  if (categoryId === '1' && subCategoryId === '2') {
    if (materialId === '2') return seoMetaKalufkiRanfors;
    if (materialId === '1') return seoMetaKalufkiSaten;
    return seoMetaSub2Kalufki;
  }
  if (categoryId === '1' && subCategoryId === '3') {
    if (materialId === '2') return seoMetaFittedSheetsRanfors;
    if (materialId === '1') return seoMetaFittedSheetsSaten;
    return seoMetaSub3CharshafiSLastik;
  }
  if (categoryId === '1' && subCategoryId === '4') {
    if (materialId === '2') return seoMetaPlikoveRanfors;
    if (materialId === '1') return seoMetaPlikoveSaten;
    return seoMetaSub4Plikove;
  }
  if (categoryId === '1' && subCategoryId === '6') {
    if (materialId === '2') return seoMetaKrugliRanfors;
    if (materialId === '1') return seoMetaKrugliSaten;
    return seoMetaSub6KrugliCharshafi;
  }
  if (categoryId === '2' && subCategoryId === '7') {
    if (materialId === '2') return seoMetaDetskiCharshafiRanfors;
    if (materialId === '1') return seoMetaDetskiCharshafiSaten;
    return seoMetaCat2Sub7DetskiCharshafi;
  }
  if (categoryId === '2' && subCategoryId === '8') {
    if (materialId === '2') return seoMetaDetskiKalufkiRanfors;
    if (materialId === '1') return seoMetaDetskiKalufkiSaten;
    return seoMetaCat2Sub8DetskiKalufki;
  }
  if (categoryId === '2' && subCategoryId === '9') {
    if (materialId === '2') return seoMetaDetskiCharshafiSLastikRanfors;
    if (materialId === '1') return seoMetaDetskiCharshafiSLastikSaten;
    return seoMetaCat2Sub9DetskiCharshafiSLastik;
  }
  if (categoryId === '2' && subCategoryId === '10') {
    if (materialId === '2') return seoMetaDetskiPlikoveRanfors;
    if (materialId === '1') return seoMetaDetskiPlikoveSaten;
    return seoMetaCat2Sub10DetskiPlikove;
  }
  return null;
}

export function ProductSeoHeader({ categoryId, subCategoryId, materialId }) {
  if (categoryId === '1' && subCategoryId === '1') {
    if (materialId === '2') return <SeoHeaderCharshafiRanfors />;
    if (materialId === '1') return <SeoHeaderCharshafiSaten />;
    return <SeoHeaderSub1Charshafi />;
  }
  if (categoryId === '1' && subCategoryId === '2') {
    if (materialId === '2') return <SeoHeaderKalufkiRanfors />;
    if (materialId === '1') return <SeoHeaderKalufkiSaten />;
    return <SeoHeaderSub2Kalufki />;
  }
  if (categoryId === '1' && subCategoryId === '3') {
    if (materialId === '2') return <SeoHeaderFittedSheetsRanfors />;
    if (materialId === '1') return <SeoHeaderFittedSheetsSaten />;
    return <SeoHeaderSub3CharshafiSLastik />;
  }
  if (categoryId === '1' && subCategoryId === '4') {
    if (materialId === '2') return <SeoHeaderPlikoveRanfors />;
    if (materialId === '1') return <SeoHeaderPlikoveSaten />;
    return <SeoHeaderSub4Plikove />;
  }
  if (categoryId === '1' && subCategoryId === '6') {
    if (materialId === '2') return <SeoHeaderKrugliRanfors />;
    if (materialId === '1') return <SeoHeaderKrugliSaten />;
    return <SeoHeaderSub6KrugliCharshafi />;
  }
  if (categoryId === '2' && subCategoryId === '7') {
    if (materialId === '2') return <SeoHeaderDetskiCharshafiRanfors />;
    if (materialId === '1') return <SeoHeaderDetskiCharshafiSaten />;
    return <SeoHeaderCat2Sub7DetskiCharshafi />;
  }
  if (categoryId === '2' && subCategoryId === '8') {
    if (materialId === '2') return <SeoHeaderDetskiKalufkiRanfors />;
    if (materialId === '1') return <SeoHeaderDetskiKalufkiSaten />;
    return <SeoHeaderCat2Sub8DetskiKalufki />;
  }
  if (categoryId === '2' && subCategoryId === '9') {
    if (materialId === '2') return <SeoHeaderDetskiCharshafiSLastikRanfors />;
    if (materialId === '1') return <SeoHeaderDetskiCharshafiSLastikSaten />;
    return <SeoHeaderCat2Sub9DetskiCharshafiSLastik />;
  }
  if (categoryId === '2' && subCategoryId === '10') {
    if (materialId === '2') return <SeoHeaderDetskiPlikoveRanfors />;
    if (materialId === '1') return <SeoHeaderDetskiPlikoveSaten />;
    return <SeoHeaderCat2Sub10DetskiPlikove />;
  }
  return null;
}

export default function ProductSeoBody({ categoryId, subCategoryId, materialId }) {
  if (categoryId === '1' && subCategoryId === '1') {
    if (materialId === '2') return <SeoBodyCharshafiRanfors />;
    if (materialId === '1') return <SeoBodyCharshafiSaten />;
    return <SeoBodySub1Charshafi />;
  }
  if (categoryId === '1' && subCategoryId === '2') {
    if (materialId === '2') return <SeoBodyKalufkiRanfors />;
    if (materialId === '1') return <SeoBodyKalufkiSaten />;
    return <SeoBodySub2Kalufki />;
  }
  if (categoryId === '1' && subCategoryId === '3') {
    if (materialId === '2') return <SeoBodyFittedSheetsRanfors />;
    if (materialId === '1') return <SeoBodyFittedSheetsSaten />;
    return <SeoBodySub3CharshafiSLastik />;
  }
  if (categoryId === '1' && subCategoryId === '4') {
    if (materialId === '2') return <SeoBodyPlikoveRanfors />;
    if (materialId === '1') return <SeoBodyPlikoveSaten />;
    return <SeoBodySub4Plikove />;
  }
  if (categoryId === '1' && subCategoryId === '6') {
    if (materialId === '2') return <SeoBodyKrugliRanfors />;
    if (materialId === '1') return <SeoBodyKrugliSaten />;
    return <SeoBodySub6KrugliCharshafi />;
  }
  if (categoryId === '2' && subCategoryId === '7') {
    if (materialId === '2') return <SeoBodyDetskiCharshafiRanfors />;
    if (materialId === '1') return <SeoBodyDetskiCharshafiSaten />;
    return <SeoBodyCat2Sub7DetskiCharshafi />;
  }
  if (categoryId === '2' && subCategoryId === '8') {
    if (materialId === '2') return <SeoBodyDetskiKalufkiRanfors />;
    if (materialId === '1') return <SeoBodyDetskiKalufkiSaten />;
    return <SeoBodyCat2Sub8DetskiKalufki />;
  }
  if (categoryId === '2' && subCategoryId === '9') {
    if (materialId === '2') return <SeoBodyDetskiCharshafiSLastikRanfors />;
    if (materialId === '1') return <SeoBodyDetskiCharshafiSLastikSaten />;
    return <SeoBodyCat2Sub9DetskiCharshafiSLastik />;
  }
  if (categoryId === '2' && subCategoryId === '10') {
    if (materialId === '2') return <SeoBodyDetskiPlikoveRanfors />;
    if (materialId === '1') return <SeoBodyDetskiPlikoveSaten />;
    return <SeoBodyCat2Sub10DetskiPlikove />;
  }
  return null;
}
